import {FC} from 'react'
import {useTranslation} from '@/translations/i18n.tsx'
import {Link} from 'react-router-dom'
import {routes} from '@utilities/constants/routes'
import CookieUsaImg from '@assets/usa_cookie.svg'

const ITEMS_CLASSNAME =
    'bg-neutral-50! text-neutral-500! border-none! p-0! flex! cursor-pointer! text-xs! underline! hover:text-neutral-900! active:text-neutral-500! items-center! gap-1! leading-[14px]!'

export const Footer: FC = () => {
    const {t} = useTranslation()
    const isUsa = Intl.DateTimeFormat().resolvedOptions().timeZone.includes('America')

    return (
        <footer className="flex h-auto items-center justify-center gap-4 border-t border-neutral-300 bg-neutral-50 md:h-12 p-4">
            {/* <a className={ITEMS_CLASSNAME} href={'https://www.airbnb.com/help/article/1128'} target={'_blank'}>
                {t('commons:terms_and_conditions')}
            </a>*/}
            <Link className={ITEMS_CLASSNAME} to={routes.PRIVACY_POLICY.handle.fullPath}>
                {t('commons:privacy_policy')}
            </Link>
            {/*<Link className={ITEMS_CLASSNAME} to={routes.COOKIE_POLICY.path}> Cookie Policy </Link>*/}
            <button id="ot-sdk-btn" className={`ot-sdk-show-settings ${ITEMS_CLASSNAME}`}>
                Cookie Settings {isUsa && <img src={CookieUsaImg} alt={'cookie-img'} />}
            </button>
        </footer>
    )
}
